import React, { useEffect, useState } from "react";
import { Spinner } from "@nike/eds";

export const MouseSpinner: React.FC = () => {
  const [pos, setPos] = useState({ x: 0, y: 0 });

  useEffect(() => {
    const handleMouseMove = (e: MouseEvent) => {
      setPos({ x: e.clientX, y: e.clientY });
    };
    window.addEventListener("mousemove", handleMouseMove);
    return () => window.removeEventListener("mousemove", handleMouseMove);
  }, []);

  return (
    <div
      style={{
        position: "fixed",
        left: pos.x + 16,
        top: pos.y + 16,
        pointerEvents: "none",
        zIndex: 9999,
      }}
    >
      <Spinner size="medium" />
    </div>
  );
};